import { http } from "@/lib/http";

export const authService = {
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  register: (data) => http.post("/auth/register", data).then((r) => r.data),
  forgotPassword: (email) => http.post("/auth/forgot-password", { email }).then((r) => r.data),
  resetPassword: (token, new_password) => http.post("/auth/reset-password", { token, new_password }).then((r) => r.data),
  acceptInvite: (data) => http.post("/auth/accept-invite", data).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  logout: () => http.post("/auth/logout"),
  setPin: (pin, password) => http.post("/auth/pin/set", { pin, password }).then((r) => r.data),
  removePin: () => http.delete("/auth/pin").then((r) => r.data),
  unlockPin: (email, pin) => http.post("/auth/pin/unlock", { email, pin }).then((r) => r.data),
};

export const journeyService = {
  state: () => http.get("/journey/state").then((r) => r.data),
  dismiss: (stepId) => http.post(`/journey/dismiss/${stepId}`).then((r) => r.data),
  restore: (stepId) => http.post(`/journey/restore/${stepId}`).then((r) => r.data),
  mark: (stepId) => http.post(`/journey/mark/${stepId}`).then((r) => r.data),
};

export const workspaceService = {
  invite: (email, name) => http.post("/workspace/invite", { email, name }).then((r) => r.data),
};

export const subscriptionService = {
  me: () => http.get("/subscription/me").then((r) => r.data),
  status: () => http.get("/billing/status").then((r) => r.data),
  checkout: (payer_email) => http.post("/billing/checkout", { payer_email }).then((r) => r.data),
  cancel: () => http.post("/billing/cancel").then((r) => r.data),
};

export const coupleService = {
  get: () => http.get("/couple").then((r) => r.data),
  update: (data) => http.put("/couple", data).then((r) => r.data),
  updateProfile: (data) => http.put("/profile", data).then((r) => r.data),
  updateCredentials: (data) => http.put("/profile/credentials", data).then((r) => r.data),
  sendMe: (kind) => http.post(`/emails/send-me/${kind}`).then((r) => r.data),
};

export const summaryService = {
  month: (month) => http.get("/summary/month", { params: { month } }).then((r) => r.data),
  raiox: () => http.get("/summary/raiox").then((r) => r.data),
  split: () => http.get("/summary/split").then((r) => r.data),
  year: (year) => http.get("/summary/year", { params: { year } }).then((r) => r.data),
  suggestions: () => http.get("/summary/suggestions").then((r) => r.data),
  investments: () => http.get("/investments").then((r) => r.data),
  invoices: (month) => http.get("/cards/invoices", { params: { month } }).then((r) => r.data),
  payInvoice: (cardId, month) => http.post(`/cards/${cardId}/pay-invoice`, { month }).then((r) => r.data),
  undoInvoice: (cardId, month) => http.delete(`/cards/${cardId}/pay-invoice/${month}`),
};

export const eventsService = {
  // ocorrências com recorrência expandida: { month } ou { start, days }
  agenda: (params) => http.get("/events/agenda", { params }).then((r) => r.data),
};

export const filesService = {
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export const collection = (name) => ({
  list: (params) => http.get(`/${name}`, { params }).then((r) => r.data),
  create: (data) => http.post(`/${name}`, data).then((r) => r.data),
  update: (id, data) => http.put(`/${name}/${id}`, data).then((r) => r.data),
  remove: (id) => http.delete(`/${name}/${id}`),
});
